// @ts-nocheck
import actionTypes from '../constants/actionTypes';
import { getByUsername } from '../api/userApi';
import { toast } from 'react-toastify';
import { updateActivation } from '../reducers/activationReducer';
import { createCompany, deleteCompany } from '../reducers/companyReducer';
import {
  createAnnouncement,
  deleteAnnouncement,
  updateAnnouncement,
} from '../reducers/announcementReducer';
import { userPermissionsChanged } from '../reducers/authReducer';
import { keyRequestSubmitted } from '../reducers/basketReducer';
import { updateBulkTransaction } from '../reducers/bulkTransactionReducer';
import {
  createCompanyType,
  deleteCompanyTypeAction,
  updateCompanyType,
} from '../reducers/companyTypeReducer';
import {
  userActive,
  userConnected,
  userDisconnected,
  userInactive,
} from '../reducers/connectedUsersReducer';
import { updateDisabledTransaction } from '../reducers/disabledTransactionReducer';
import {
  processingGameSkuPricingUpload,
  uploadGameSkuPricingFailure,
} from '../reducers/gameSKUPricingUploadReducer';
import { processingGameUpload } from '../reducers/gameUploadReducer';
import { createGame, updateGame } from '../reducers/gameReducer';

export function configureSubscriptions(connection, dispatch) {
  // KEY PROVIDER ---------------------------------------------------
  connection.on('KeyProviderCreated', (keyProvider) => {
    dispatch({ type: actionTypes.CREATE_KEYPROVIDER, keyProvider });
  });

  connection.on('KeyProviderDeleted', (id) => {
    dispatch({ type: actionTypes.DELETE_KEYPROVIDER, id });
  });

  // PLATFORM ---------------------------------------------------
  connection.on('PlatformCreated', (platform) => {
    dispatch({ type: actionTypes.CREATE_PLATFORM, platform });
  });

  connection.on('PlatformDeleted', (id) => {
    dispatch({ type: actionTypes.DELETE_PLATFORM, id });
  });

  // COMPANY ---------------------------------------------------
  connection.on('CompanyCreated', (company) => {
    dispatch(createCompany(company));
  });
  connection.on('CompanyDeleted', (id) => {
    dispatch(deleteCompany(id));
  });

  // COMPANYTYPE ---------------------------------------------------
  connection.on('CompanyTypeCreated', (companyType) => {
    dispatch(createCompanyType(companyType));
  });
  connection.on('CompanyTypeUpdated', (companyType) => {
    dispatch(updateCompanyType(companyType));
  });
  connection.on('ConpanyTypeDeleted', (id) => {
    dispatch(deleteCompanyTypeAction(id));
  });

  // WORKFLOW ---------------------------------------------------
  connection.on('KeyWorkflowCreated', (workflow) => {
    dispatch({ type: actionTypes.CREATE_WORKFLOW, workflow });
  });
  connection.on('KeyWorkflowDeleted', (id) => {
    dispatch({ type: actionTypes.DELETE_WORKFLOW, id });
  });
  connection.on('KeyWorkflowUpdated', (workflow) => {
    dispatch({ type: actionTypes.UPDATE_WORKFLOW, workflow });
  });

  // GAME ---------------------------------------------------
  connection.on('GameCreated', (game) => {
    dispatch(createGame(game));
  });
  connection.on('GameUpdated', (game) => {
    dispatch(updateGame(game));
  });
  connection.on('GameUploadProcessing', (progress) => {
    dispatch(processingGameUpload(progress));
  });

  // GAME SKU ---------------------------------------------------
  connection.on('GameSKUCreated', (sku) => {
    // TODO: WHAT DO WE NEED TO DO HERE?
  });
  connection.on('GameSKUUpdated', (sku) => {
    // TODO: WHAT DO WE NEED TO DO HERE?
  });
  connection.on('GameSKUPricingUploadProcessing', (progress) => {
    dispatch(processingGameSkuPricingUpload(progress));
  });
  connection.on('GameSKUPricingUploadFailed', (data) => {
    dispatch(uploadGameSkuPricingFailure(data));
  });

  // TERRITORY ---------------------------------------------------
  connection.on('TerritoryCreated', (territory) => {
    dispatch({ type: actionTypes.CREATE_TERRITORY, territory });
  });
  connection.on('TerritoryDeleted', (id) => {
    dispatch({ type: actionTypes.DELETE_TERRITORY, id });
  });

  // PACKAGE ---------------------------------------------------
  connection.on('PackageTypeCreated', (packageType) => {
    dispatch({ type: actionTypes.CREATE_PACKAGETYPE, packageType });
  });

  // STEAM REQUEST ---------------------------------------------
  connection.on('SteamRequestUpdated', (steamRequest) => {
    dispatch({ type: actionTypes.UPDATE_STEAMREQUEST, steamRequest });
  });

  //IMPORT TRANSACTIONS ----------------------------------------
  connection.on('UpdatedKeyCodeProcessingProgress', (importTransaction) => {
    dispatch({
      type: actionTypes.UPDATE_IMPORT_TRANSACTION,
      transaction: importTransaction,
    });
  });
  connection.on('KeyCodeProcessingFailed', (importTransaction) => {
    dispatch({
      type: actionTypes.UPDATE_IMPORT_TRANSACTION,
      transaction: importTransaction,
    });
  });

  //ACTIVATIONS --------------------------------------------------
  connection.on('ActivatedKeyCodeProcessingFailed', (activation) => {
    dispatch(updateActivation(activation));
  });

  connection.on('UpdatedActivatedKeyCodeProcessingProgress', (activation) => {
    dispatch(updateActivation(activation));
  });

  //DISABLED TRANSACTIONS --------------------------------------------
  connection.on('DisabledKeyCodeProcessingFailed', (disabledTransaction) => {
    dispatch(updateDisabledTransaction(disabledTransaction));
  });

  connection.on(
    'UpdatedDisabledKeyCodeProcessingProgress',
    (disabledTransaction) => {
      dispatch(updateDisabledTransaction(disabledTransaction));
    }
  );

  connection.on('UpdatedDisabledImportTransaction', (disabledTransaction) => {
    dispatch(
      updateDisabledTransaction({
        ...disabledTransaction,
        status: 'reload',
      })
    );
  });

  //SOLD TRANSACTIONS --------------------------------------------
  connection.on('SoldKeyCodeProcessingFailed', (soldTransaction) => {
    dispatch({
      type: actionTypes.UPDATE_SOLD_TRANSACTION,
      transaction: soldTransaction,
    });
  });

  connection.on('UpdatedSoldKeyCodeProcessingProgress', (soldTransaction) => {
    dispatch({
      type: actionTypes.UPDATE_SOLD_TRANSACTION,
      transaction: soldTransaction,
    });
  });

  //MOVE TRANSACTIONS --------------------------------------------
  connection.on('MoveKeyCodeProcessingFailed', (moveTransaction) => {
    dispatch({
      type: actionTypes.UPDATE_MOVE_TRANSACTION,
      transaction: moveTransaction,
    });
  });

  connection.on('UpdatedMoveKeyCodeProcessingProgress', (moveTransaction) => {
    dispatch({
      type: actionTypes.UPDATE_MOVE_TRANSACTION,
      transaction: moveTransaction,
    });
  });

  //BULK UPLOAD --------------------------------------------------
  connection.on('KeyCodeBulkProcessingFailed', (transaction) => {
    dispatch(updateBulkTransaction(transaction));
  });

  connection.on('KeyCodeBulkProcessingProgress', (transaction) => {
    dispatch(updateBulkTransaction(transaction));
  });

  //USER --------------------------------------------
  connection.on('PermissionsChanged', () => {
    getByUsername()
      .then((currentUser) => {
        dispatch(userPermissionsChanged(currentUser));
      })
      .catch((e) => {
        console.error('Failed to update permissions');
      });
  });

  // KEY REQUEST --------------------------------------
  connection.on('KeyRequestGroupSubmitted', (keyRequestGroup) => {
    dispatch(keyRequestSubmitted(keyRequestGroup));

    toast.success('Successfully submitted');
  });

  // SIGNALR --------------------------------------------
  connection.on('UserConnected', (user) => {
    dispatch(userConnected(user));
  });

  connection.on('UserDisconnected', (user) => {
    dispatch(userDisconnected(user));
  });

  connection.on('UserActive', (username) => {
    dispatch(userActive(username));
  });

  connection.on('UserInactive', (username) => {
    dispatch(userInactive(username));
  });

  // ANNOUNCEMENTS ---------------------------------------------------
  connection.on('AnnouncementCreated', (announcement) => {
    dispatch(createAnnouncement(announcement));
  });
  connection.on('AnnouncementUpdated', (announcement) => {
    dispatch(updateAnnouncement(announcement));
  });
  connection.on('AnnouncementDeleted', (announcement) => {
    dispatch(deleteAnnouncement(announcement.id));
  });
}
